<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="title-box">
            <div class="manufacture-t1">
                蜂巢动力系统（江苏）有限公司
            </div>
            <div class="manufacture-t2">
                蜂巢动力系统（江苏）有限公司是蜂巢汽车科技集团有限公司旗下的全资子公司，位于江苏省常州市武进区。公司占地面积约100亩，建筑面积约5万平方米，主要从事发动机、变速器等汽车动力总成产品的研发、生产和销售。公司拥有先进的生产设备和技术团队，致力于为客户提供高效节能环保的汽车动力总成解决方案。
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                智能制造
            </div>
            <div class="page-t2">
                为客户提供高效节能环保的汽车动力总成解决方案
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/about/kv.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                蜂巢汽车科技集团有限公司
                            </div>
                            <div class="destils">
                                引进德国高端卧式加工中心、NAGEL 珩磨机、勇克及兰蒂斯高精磨床，定位精度≤0.004mm、重复定位精度≤0.002mm，保障超精磨削与复杂结构切削品质
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/about/kv.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                蜂巢汽车科技集团有限公司
                            </div>
                            <div class="destils">
                                引进德国高端卧式加工中心、NAGEL 珩磨机、勇克及兰蒂斯高精磨床，定位精度≤0.004mm、重复定位精度≤0.002mm，保障超精磨削与复杂结构切削品质
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/about/kv.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                蜂巢汽车科技集团有限公司
                            </div>
                            <div class="destils">
                                引进德国高端卧式加工中心、NAGEL 珩磨机、勇克及兰蒂斯高精磨床，定位精度≤0.004mm、重复定位精度≤0.002mm，保障超精磨削与复杂结构切削品质
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '智能制造 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture-detail.html'
};

import { createApp } from 'vue';
import App from './manufacture-detail.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./manufacture-detail.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
